const getCurrentHourOption = () => {
  const currentMinutes =
    new Date(Date.now()).getMinutes() >= 45
      ? '75'
      : new Date(Date.now()).getMinutes() >= 30 &&
        new Date(Date.now()).getMinutes() < 45
      ? '5'
      : new Date(Date.now()).getMinutes() >= 15 &&
        new Date(Date.now()).getMinutes() < 30
      ? '25'
      : '00';

  return +`${new Date(Date.now()).getHours()}.${currentMinutes}`;
};

export default getCurrentHourOption;
